import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function useFileProcessor() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const {
    t,
    i18n: { language },
  } = useTranslation("global");

  const urlEndpointImgProcessor =
    "https://monaco-dermatology-python-54644131242.us-central1.run.app/analyze-skin";

  const uploadFileProcessor = async (docData, msg, type) => {
    setLoading(true);

    const fd = new FormData();
    docData.forEach((file) => {
      fd.append("files", file);
    });

    fd.append("doctor_message", msg);

    return new Promise(function (resolve, reject) {
      axios
        .post(urlEndpointImgProcessor.toString(), fd)
        .then((response) => {
          setLoading(false);
          setData(response);
          resolve(response);
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          reject(error);
        });
    });
  };

  const cleanAction = () => {
    setData(null);
    setLoading(false);
    setError(null);
  };

  return {
    uploadFileProcessor,
    data,
    loading,
    error,
    cleanAction,
  };
}
